import { useLocation } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import { useContext, useEffect } from "react";
import axios from "../axios/axios";
function Home() {
    // useEffect(() => {
    //     axios.get("/", {
    //         authorization: token
    //     }).then((data) => {
    //         console.log({data});
    //     });
        
    // }, [])
    const {token} = useContext(AuthContext)
    return <div>{token}</div>
}
export default Home